enum Gender {
    Unknown	= 0,
    Male = 1,
    Female = 2,
    NonBinary = 3,
    Transgender = 4,
    Intersex = 5,
    PreferNotToSay = 20,
}

export default Gender;